/**
 * Shared "showing X-Y of Z" notice plus page control for the ADSP tree levels.
 * Every level paginates server-side, so this keeps the count line, in-flight
 * spinner, and pagination affordance consistent from the CCG root down to assets.
 */
import React from 'react';
import MeridianLoader from '@amzn/meridian/loader';
import Pagination from '@amzn/meridian/pagination';
import Row from '@amzn/meridian/row';
import { ShowingCount } from 'src/components/common/data-table-action-bar/ShowingCount';
import type { PaginatedMetaPaginationDocumented } from 'src/store/generated/leela-api-generated';

interface AdspPaginationFooterProps {
  isFetching: boolean;
  page: number;
  pagination: PaginatedMetaPaginationDocumented;
  testId: string;
  onPageChange: (page: number) => void;
}

export const AdspPaginationFooter: React.FC<AdspPaginationFooterProps> = ({
  isFetching,
  onPageChange,
  page,
  pagination,
  testId,
}) => {
  if (pagination.total === 0) return null;

  return (
    <Row alignmentHorizontal="justify" alignmentVertical="center">
      <Row alignmentVertical="center" spacing="200">
        <ShowingCount page={page} pageSize={pagination.pageSize} total={pagination.total} />
        {isFetching && <MeridianLoader size="small" type="linear" />}
      </Row>
      {pagination.pageCount > 1 && (
        <Pagination
          currentPage={page}
          data-testid={`${testId}-pagination`}
          numberOfPages={Math.max(1, pagination.pageCount)}
          onChange={onPageChange}
        />
      )}
    </Row>
  );
};
